import { render, staticRenderFns } from "./website-header.vue?vue&type=template&id=37af4bd2&scoped=true"
import script from "./website-header.vue?vue&type=script&lang=js"
export * from "./website-header.vue?vue&type=script&lang=js"
import style1 from "./website-header.vue?vue&type=style&index=1&id=37af4bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af4bd2",
  null
  
)

export default component.exports